import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['template', 'list', 'emptyListMsg'];
  declare readonly templateTarget: HTMLTemplateElement;
  declare readonly emptyListMsgTarget?: HTMLElement;
  declare readonly hasEmptyListMsgTarget: boolean;
  declare readonly listTarget: HTMLElement;

  connect() {
  }

  removeField = e => {
    e.preventDefault();
    const nestedForm = e.currentTarget.closest('.nested-form'),
        newRecord = nestedForm.getAttribute('data-new-record') === 'true';
    if (newRecord) nestedForm.remove();
    else {
      nestedForm.querySelector('input.destroy').value = '1';
      nestedForm.classList.add('hidden');
    }
  }

  removeAll = e => {
    e.preventDefault();
    this.element.querySelectorAll('.nested-form').forEach(nestedForm => {
      const newRecord = nestedForm.getAttribute('data-new-record') === 'true';
      if (newRecord) nestedForm.remove();
      else {
        const destroyInput = nestedForm.querySelector('input.destroy') as HTMLInputElement;
        if (destroyInput) destroyInput.value = '1';
        nestedForm.classList.add('hidden');
      }
    })
  }

  addField = (e) => {
    e.preventDefault();
    const clone = this.templateTarget.content.cloneNode(true) as HTMLElement;
    this.listTarget.appendChild(document.importNode(clone, true))
    const newItem = this.listTarget.children[this.listTarget.children.length - 1];
    const html = newItem.outerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString());
    const replacement = document.createElement('li');
    replacement.innerHTML = html;
    newItem.replaceWith(replacement.children[0]);
    this.listTarget.classList.remove('hidden');
    if (this.hasEmptyListMsgTarget) this.emptyListMsgTarget.classList.add('hidden');
  }
}
